import { useMemo } from 'react';
import { useParams, usePathname } from 'next/navigation';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

// Lib
import { layoutHeaderBackLinks } from '@/lib/layout/layoutHeaderBackLink';

import { BackLinks } from '@/components/layouts/LayoutPlatform/components/Header/LeftSide/BackLinks';
// Components
import { DefaultLeftSide } from '@/components/layouts/LayoutPlatform/components/Header/LeftSide/DefaultLeftSide';

export function LeftSide() {
    const pathname = usePathname();
    const params = useParams();

    const backLink = useMemo(() => {
        let backLinkToDisplay: (typeof layoutHeaderBackLinks)[number] = null;
        layoutHeaderBackLinks.forEach((item) => {
            if (formatUrls(item.urls, params).includes(pathname)) {
                backLinkToDisplay = item;
            }
        });

        return backLinkToDisplay;
    }, [pathname, params]);

    if (backLink) {
        return <BackLinks backLink={backLink} />;
    }
    return <DefaultLeftSide />;
}
